"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageIdFromManifest = exports.getManifestLayers = exports.extractArchive = void 0;
const path_1 = require("path");
const types_1 = require("../../types");
var layer_1 = require("./layer");
Object.defineProperty(exports, "extractArchive", { enumerable: true, get: function () { return layer_1.extractArchive; } });
function getManifestLayers(manifest) {
    return manifest.Layers.map((layer) => (0, path_1.normalize)(layer));
}
exports.getManifestLayers = getManifestLayers;
function getImageIdFromManifest(manifest) {
    try {
        const imageId = manifest.Config.split(".")[0];
        if (imageId.includes(":")) {
            // imageId includes the algorithm prefix
            return imageId;
        }
        return `${types_1.HashAlgorithm.Sha256}:${imageId}`;
    }
    catch (err) {
        throw new Error("Failed to extract image ID from archive manifest");
    }
}
exports.getImageIdFromManifest = getImageIdFromManifest;
//# sourceMappingURL=index.js.map